import * as utils from '@/utils/utils'
import { isMobile } from '@/utils/platform'
import { setVariable } from '@/utils/exportVariable'
import { walletAccessibleRegions } from '@/consts/index'
import { queryAccountBalance } from '@/api/wallet'
import { getI18nMessages } from '@/api/i18n'
import { CURRENCY_CONFIG } from '@/utils/currencyConfig.js'
import {
  countryConfigs,
  getI18nDefaultLang,
  getAllLanguages,
} from '@/config/country'
import { apiInit } from '@/api/init'
import { getVersion } from '@/utils/toplupeVersion.js'
import setCluster from '@/utils/setCluster'

const isDEV = process.env.VUE_APP_ENV === 'dev'

const getLanguage = (query, ssrLocationParams = {}) => {
  // query中的lang，如果存在lang，则优化按照query中的lang加载文案
  const queryLang =
    query.lang && getAllLanguages().includes(query.lang) ? query.lang : ''

  let language =
    queryLang ||
    (countryConfigs[utils.region(ssrLocationParams)] || {}).i18n ||
    getI18nDefaultLang()

  return language
}

export default {
  async nuxtServerInit({ commit }, context) {
    const { route, query = {}, req } = context
    const detectedHost = req?.headers?.['x-forwarded-host'] || req?.headers.host
    const ssrLocationParams = {
      host: detectedHost,
      url: req?.url,
      health_checks: req?.headers?.['is-health-examination'] || '',
    }
    let language = getLanguage(query, ssrLocationParams)

    setVariable('context', context)

    language = utils.hackGameDefaultLanguage(context, language)

    const i18nMessages = isDEV ? {} : getI18nMessages(language)

    const currentIsMobile = !!isMobile() // 是否为移动端
    const isDesktop = !isMobile() // 是否为桌面设备
    const isMiuiBrowser = utils.isMiuiBrowser() // 是否为国际版小米浏览器
    const isXiaomiDevice = utils.isXiaomiDevice() // 是否为小米设备
    const isChromeBrowser = utils.isChromeBrowser() // 是否为小米设备
    const isApp = utils.isInCoinsApp() // 是否为APP
    const isTurbo = route.query.mode === 'gt' && currentIsMobile
    const isPwa = !!utils.isPwa()
    const region = utils.region()
    const currencySymbol = CURRENCY_CONFIG[region]
      ? CURRENCY_CONFIG[region].currencySymbol
      : ''
    const gameName =
      (route.query.gameName && route.query.gameName.toLowerCase()) ||
      (route.params.gameName && route.params.gameName.toLowerCase()) ||
      route.name

    const allowUseMember = walletAccessibleRegions.indexOf(region) > -1 // 根据国家屏蔽入口

    const layoutVersion = getVersion()

    commit('changeStore', {
      isMobile: currentIsMobile,
      isDesktop,
      isMiuiBrowser,
      isXiaomiDevice,
      isChromeBrowser,
      isApp,
      isTurbo,
      isPwa,
      region,
      gameName,
      allowUseMember,
      i18nMessages,
      currency: currencySymbol,
      layoutVersion,
    })

    // warn 使用跟详情一样的国家传递方式
    const { pathMatch } = context?.params || {}
    const country = pathMatch || 'id' // 默认印尼
    const matrixClusterName = process.env.MATRIX_CLUSTER_NAME || ''
    const matrixCountry =
      setCluster({
        cluster: matrixClusterName,
        type: true,
        locations: ssrLocationParams,
      }) || country

    const apiSign = await apiInit(matrixCountry, context)

    if (apiSign && Object.keys(apiSign).length) {
      commit('common/setApiSign', apiSign)
    }
  },
  async getWalletBalance({ commit, state }) {
    // 查询账户信息
    try {
      const { userInfo = {} } = state
      if (!(userInfo && userInfo.kicoinId)) {
        return
      }
      const res = await queryAccountBalance({
        accountType: 1, //K币账户
        userId: userInfo.kicoinId,
      })
      commit('setPaymentAccountInfo', res || {})
      res && commit('pay/setAccountBalance', res.amount || 0)
      return Promise.resolve(res || {})
    } catch (e) {
      commit('setPaymentAccountInfo', {})
      return Promise.reject({})
    }
  },
}
